import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Input, Select, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import ModalItem from "./ModalItem";
import ButtonItem from "./ButtonItem";
import SelectItem from "./SelectItem";
import InputItem from "./InputItem";
import InputNumberItem from "./InputNumberItem";
import DatePickerItem from "./DatePickerItem";

const { Option } = Select;

class SelectValorCategoriaItem extends Component {
  state = {
    modalOpen: false,
    nuevoValor: null,
    nuevaUnidad: "",
    loading: false,
  };

  abrirModal = () => {
    this.setState({ modalOpen: true, nuevoValor: null, nuevaUnidad: "" });
  };

  cerrarModal = () => {
    this.setState({ modalOpen: false });
  };

  guardar = () => {
    const { nuevoValor } = this.state;
    if (
      nuevoValor === null ||
      nuevoValor === undefined ||
      (typeof nuevoValor === "string" && nuevoValor.trim() === "")
    ) {
      message.warning("Ingresa un valor");
      return;
    }
    const valorBackend = moment.isMoment(nuevoValor)
      ? nuevoValor.toISOString()
      : nuevoValor;

    this.setState({ loading: true });
    axios
      .post(
        "valoresCategoriaInsumo/agregarValorCategoria",
        {
          categoriaInsumoId: this.props.categoria._id,
          empresaId: this.props.empresaId,
          valor: valorBackend,
          unidad: this.state.nuevaUnidad || "",
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data && res.data.success === 2) {
          message.success("Valor agregado");
          const nuevoId = res.data.codigo;
          this.setState({
            modalOpen: false,
            nuevoValor: null,
            nuevaUnidad: "",
            loading: false,
          });
          if (this.props.onValorAgregado) {
            this.props.onValorAgregado(nuevoId);
          }
          if (this.props.onChange) {
            this.props.onChange(nuevoId);
          }
        } else {
          this.setState({ loading: false });
          message.error(
            (res.data && res.data.message) || "No se pudo agregar el valor"
          );
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al agregar valor");
      });
  };

  renderInputValor = (value, onChange) => {
    const tipo = this.props.categoria?.tipoDato;
    const style = { width: "100%" };
    if (tipo === "numero") {
      return (
        <InputNumberItem
          value={value}
          onChange={onChange}
          placeholder="Valor numérico"
          style={style}
        />
      );
    }
    if (tipo === "fecha") {
      return (
        <DatePickerItem
          value={value}
          onChange={onChange}
          format="DD/MM/YYYY"
          style={style}
        />
      );
    }
    if (tipo === "booleano") {
      return (
        <Select
          value={value === null || value === undefined ? undefined : value}
          onChange={onChange}
          placeholder="Seleccionar"
          style={style}
        >
          <Option value={true}>Sí</Option>
          <Option value={false}>No</Option>
        </Select>
      );
    }
    return (
      <InputItem
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Valor"
        style={style}
      />
    );
  };

  render() {
    const {
      categoria,
      valores,
      value,
      onChange,
      empresaId,
      headersToken,
      onValorAgregado,
      ...rest
    } = this.props;
    if (!categoria) return null;

    const tipo = categoria.tipoDato;
    const esBooleano = tipo === "booleano";
    const valoresActivos = (valores || []).filter((v) => v.estado === 1);

    return (
      <>
        <Input.Group compact style={{ display: "flex", width: "100%" }}>
          <SelectItem
            value={value}
            onChange={onChange}
            placeholder="Seleccionar valor"
            allowClear
            style={{ flex: 1, minWidth: 0 }}
            {...rest}
          >
            {valoresActivos.map((v) => {
              let label = String(v.valor);
              if (tipo === "booleano") label = v.valor ? "Sí" : "No";
              if (tipo === "fecha") {
                const m = moment(v.valor);
                label = m.isValid() ? m.format("DD/MM/YYYY") : label;
              }
              if (tipo === "numero" && v.unidad)
                label = `${label} ${v.unidad}`;
              return (
                <Option key={v._id} value={v._id}>
                  {label}
                </Option>
              );
            })}
          </SelectItem>
          {!esBooleano && this.props.permisoAgregarValor && (
            <ButtonItem
              icon={<PlusOutlined />}
              style={{ width: 28, height: 28, marginLeft: 5, flexShrink: 0 }}
              onClick={this.abrirModal}
              tooltip="Agregar nuevo valor"
            />
          )}
        </Input.Group>

        <ModalItem
          title={`Agregar valor a: ${categoria.nombre}`}
          visible={this.state.modalOpen}
          spinning={this.state.loading}
          onCancel={this.cerrarModal}
          paddingTop
          width={500}
          footer={false}
        >
          {categoria.descripcion ? (
            <div
              style={{
                marginBottom: 12,
                padding: "8px 10px",
                background: "#f6faff",
                border: "1px solid #d6e4ff",
                borderRadius: 4,
                fontSize: 12,
                color: "#3b4a66",
              }}
            >
              {categoria.descripcion}
            </div>
          ) : null}
          <div style={{ display: "flex", gap: 10, alignItems: "flex-end" }}>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: 11,
                  color: "#6b7280",
                  marginBottom: 4,
                  fontWeight: 500,
                }}
              >
                Valor
              </div>
              {this.renderInputValor(this.state.nuevoValor, (v) =>
                this.setState({ nuevoValor: v })
              )}
            </div>
            {tipo === "numero" && (
              <div style={{ width: 160 }}>
                <div
                  style={{
                    fontSize: 11,
                    color: "#6b7280",
                    marginBottom: 4,
                    fontWeight: 500,
                  }}
                >
                  Unidad (opcional)
                </div>
                <InputItem
                  value={this.state.nuevaUnidad}
                  onChange={(e) =>
                    this.setState({ nuevaUnidad: e.target.value })
                  }
                  placeholder="Ej. Mts, KG, V"
                />
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 8,
              marginTop: 18,
            }}
          >
            <ButtonItem onClick={this.cerrarModal}>Cancelar</ButtonItem>
            <ButtonItem
              type="primary"
              olivo
              icon={<PlusOutlined />}
              onClick={this.guardar}
            >
              Agregar
            </ButtonItem>
          </div>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  permisoAgregarValor:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a0c8ead95cdbbe290cdf82e"
    )?.activado,
});

export default connect(mapStateToProps)(SelectValorCategoriaItem);
